import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { ClientError } from "graphql-request";

import { graphql } from "lib/generated/app-service-gql";
import {
  DocumentBuyingSignalsStartMutation,
  DocumentBuyingSignalsStartMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { documentBuyingSignalsQueryKey } from "./useDocumentBuyingSignals";

const documentBuyingSignalsStartMutation = graphql(`
  mutation documentBuyingSignalsStart($request: DocumentsSearchRequest!) {
    documentBuyingSignalsStart(DocumentsSearchRequest: $request) {
      operationId
      status
    }
  }
`);

export function useDocumentBuyingSignalsStart(
  options?: UseMutationOptions<
    DocumentBuyingSignalsStartMutation,
    ClientError,
    DocumentBuyingSignalsStartMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  return useGraphQlMutation(documentBuyingSignalsStartMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      // Bridge the gap between the mutation returning and the first PubSub `running` event by
      // writing the running status straight into the cached query for these filters.
      queryClient.setQueryData(documentBuyingSignalsQueryKey(variables.request), {
        documentBuyingSignals: {
          operationId: data.documentBuyingSignalsStart.operationId,
          status: "running",
          result: null,
        },
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
}
